import React, { useEffect, useRef } from 'react';
import { MDBRow, MDBCol, MDBTable, MDBTableHead, MDBTableBody, MDBCarousel, MDBCarouselItem, MDBTypography } from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';

const CategoriesCarousel = ({ categories }) => {
  const carouselRef = useRef(null);
  const activeItemRef = useRef(null);

  const adjustCarouselHeight = () => {
    if (carouselRef.current && activeItemRef.current) {
      const activeItemHeight = activeItemRef.current.scrollHeight;
      carouselRef.current.style.height = `${activeItemHeight}px`;
    }
  };

  useEffect(() => {
    const handleSlideChange = () => {
      setTimeout(() => {
        adjustCarouselHeight();
      }, 500);
    };

    if (carouselRef.current) {
      carouselRef.current.addEventListener('slid.bs.carousel', handleSlideChange);
    }

    adjustCarouselHeight();

    return () => {
      if (carouselRef.current) {
        carouselRef.current.removeEventListener('slid.bs.carousel', handleSlideChange);
      }
    };
  }, []);

  return (
    <MDBCarousel showIndicators dark keyboard pause="hover" fade className="mb-3 d-flex" ref={carouselRef}  interval={20000 * categories.length}>
      {categories.map((category, catIndex) => (
        <MDBCarouselItem key={catIndex} className="w-100 d-block"  interval={20000} ref={catIndex === 0 ? activeItemRef : null} itemId={catIndex+1} >
          <MDBRow>
            <MDBCol lg="8" className="mx-auto">
             
            
            <figure className='mb-0'>
  <MDBTypography blockquote>
    <h3 className="text-center">{category.name}</h3>
  </MDBTypography>
  {category.info && category?.info?.map((inf, infInd) => (
    <figcaption className='blockquote-footer mb-2' key={infInd}>
      <cite className='text-primary' title={inf}>{inf}</cite>
    </figcaption>
  ))}
</figure>

      

              <MDBTable bordered>
                <MDBTableHead className="table-success">
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Price</th>
                  </tr>
                </MDBTableHead>
                <MDBTableBody>
                  {category.items.map((item, index) => (
                    <>
                   {(item.price || item.price===0.0) &&   <tr key={index}>
                        <th scope="row">{index + 1}</th>
                        <td className='text-start'>   <figure className='mb-0'>
      <MDBTypography blockquote>
        <p>{item.name}</p>
      </MDBTypography>
    {item.note &&   <figcaption className='blockquote-footer mb-0'>
        <cite className='text-success' title={item.note}>{item.note}</cite>
      </figcaption>}
    </figure></td>
                     

                        <td className='text-start'> 
                          {item.price ? `$${item.price}${item.per ? ` ${item.per}` : ''}` : `${item.per}`}
                        </td>
                      </tr>}
                      {/* Render bundles as a nested table */}
                      {item.items && (
                        <tr>
                          <td colSpan="3">
                            <h5 className="text-center">Bundle Items</h5>
                            <MDBTable bordered>
                             
                              <MDBTableBody>
                                {item.items.map((bundleItem, bundleIndex) => (
                                  <tr key={bundleIndex}>
                                    <th scope="row">{bundleIndex + 1}</th>
                                    <td className='text-start'>   <figure className='mb-0'>
      <MDBTypography blockquote>
        <p>{bundleItem.name}</p>
      </MDBTypography>
    {bundleItem.note &&   <figcaption className='blockquote-footer mb-0'>
        <cite className='text-success' title={bundleItem.note}>{bundleItem.note}</cite>
      </figcaption>}
    </figure></td>
                                    <td className='text-start'>{bundleItem.price ? `$${bundleItem.price}${bundleItem.per ? ` ${bundleItem.per}` : ''}` : 'N/A'}</td>
                                  </tr>
                                ))}
                              </MDBTableBody>
                            </MDBTable>
                          </td>
                        </tr>
                      )}
                    </>
                  ))}
                </MDBTableBody>
              </MDBTable>
            </MDBCol>
          </MDBRow>
        </MDBCarouselItem>
      ))}
    </MDBCarousel>
  );
};

CategoriesCarousel.propTypes = {
  categories: PropTypes.array.isRequired,
};

export default CategoriesCarousel;
